export const operationalHoursError = 'Temporarily Unavailable';
